<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (dataExportToExcel)="exportToExcel()"
                   (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
                   [showSearch]="showSearch" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"
                   [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Add Holidays</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

        <!--<div class="form-group">-->
        <!--<select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="optionSelected"-->
        <!--(change)="onOptionChange($event.target.selectedIndex)">-->
        <!--<option *ngFor="let option of options" [value]="option.id">{{option.name}}</option>-->
        <!--</select>-->
        <!--</div>-->
        <!--<div class="others"[hidden] ="isSameasClient" >-->

        <div class="form-group">
            <input class="form-control radius-0 font-13" [(ngModel)]="desc" placeholder="Description">
        </div>
        <div class="form-group">

            <!--<app-ngb-multi-date-picker [datesSelected]="datesSelected"-->
            <!--(datesSelectedChange)="change($event)"></app-ngb-multi-date-picker>-->
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5"
                   placeholder="Holiday" [(ngModel)]="holidays" readonly>
            <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>

        </div>
        <div class="form-group font-13">
            <mat-radio-group (change)="onButtonChange($event)">
                <mat-radio-button value="F" [checked]="true">Full Day</mat-radio-button> &nbsp;
                <mat-radio-button value="H">Partial Day</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="form-group" [hidden]="isHidden">
            <input class="form-control radius-0 font-13" readonly [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13"
                   placeholder="Holiday Start" [(ngModel)]="hourStart">
            <owl-date-time [pickerType]="'timer'" #dt13></owl-date-time>
        </div>
        <!--</div>-->

        <div class="form-group matFrom">
            <!-- <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected">
              <option *ngFor="let group of support_group" [value]="group.id">{{group.name}}</option>
            </select> -->
            <mat-form-field>
                <mat-label class="font-13">Select support group</mat-label>
                <mat-select [(ngModel)]="groupSelected" multiple>
                    <mat-option *ngFor="let group of support_group" [value]="group.id"
                                class="font-13">{{group.name}}</mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Search</div>

    </div>
    <div class="modal-body">
        <div class="form-group mar_top">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1"
                   placeholder=" Enter Holiday Date" [(ngModel)]="sholidays" readonly>
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>

</ng-template>

<notifier-container></notifier-container>
